import { render } from "./WaitingPanel.vue?vue&type=template&id=10e0f517&scoped=true"
import script from "./WaitingPanel.vue?vue&type=script&lang=js"
export * from "./WaitingPanel.vue?vue&type=script&lang=js"

import "./WaitingPanel.vue?vue&type=style&index=0&id=10e0f517&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e0f517"]])

export default __exports__